import none from '../../img/kandokLogo.jpg'
export const coldDrink =[
 {
  "id": 81,
  "title": "شیر موز",
  "price": 70,
  "image": none
 },
 {
  "id": 82,
  "title": "آب میوه فصل",
  "price": 70,
  "image": none
 },
 {
  "id": 83,
  "title": "آب زرشک",
  "price": 60,
  "image": none
 },
 {
  "id": 84,
  "title": "آب آلبالو",
  "price": 60,
  "image": none
 },
 {
  "id": 85,
  "title": "نوشیدنی کالسیک ویژه کندوک",
  "price": 105,
  "image": none
 }
]